export default "__VITE_ASSET__dvTJl1If__"